module.exports = __webpack_public_path__ + "img/menu_cross.e24b75f1.svg";